module.exports = __webpack_public_path__ + "static/tier_ugo-d240544257b92e9fbe3b4f2b63e901c5.svg";